import moment from 'moment'
import { capitalize } from './stringsUtils'

export const formatDateInput = (raw) => {
  const digits = raw.replace(/\D/g, '').slice(0, 8);

  const dd = digits.slice(0, 2);
  const mm = digits.slice(2, 4);
  const yyyy = digits.slice(4, 8);

  let out = dd;
  if (mm) out += '/' + mm;
  if (yyyy) out += '/' + yyyy;

  return out;
};

export const normalizeDateOnBlur = (value) => {
  const parts = value.split('/');
  if (parts.length !== 3) return value;

  let [d, m, y] = parts.map(p => p.replace(/\D/g, ''));
  if (!d && !m && !y) return '';

  d = d.padStart(2, '0').slice(0, 2);
  m = m.padStart(2, '0').slice(0, 2);
  y = y.padStart(4, '0').slice(0, 4);

  return `${d}/${m}/${y}`;
};

export const parseARDate = (ddmmyyyy = '') => {
  const [dd, mm, yyyy] = ddmmyyyy.split('/')
  if (!dd || !mm || !yyyy) return null
  return new Date(Number(yyyy), Number(mm) - 1, Number(dd))
}

export const toNumberSafe = (value) => {
  const n = Number(String(value ?? '').replace(/[^\d]/g, ''))
  return Number.isFinite(n) ? n : 0
}

export const formatAppointmentDate = (appointment, emptyValue = '-') => {
  const rawDate = appointment?.fechaTurnoDateTime || appointment?.fechaTurno

  if (!rawDate) {
    return emptyValue
  }

  const date = moment.parseZone(rawDate)

  if (!date.isValid()) {
    return appointment?.fechaTurno || emptyValue
  }

  const month = date.locale('es').format('MMMM')
  const monthCapitalized = capitalize(month, true)

  return `${date.format('D [de]')} ${monthCapitalized} ${date.format('YYYY [a las] HH:mm')}`
}
